module.exports = __webpack_public_path__ + "img/img-14.924a6cf9.webp";